import { useSelectCustomers } from '@hooks';
import { L } from '@lib';
import { Select } from 'antd';
import { observer } from 'mobx-react';
import React, { useMemo } from 'react';

interface IProps {
  placeholder?: string;
  status?: 'error' | 'warning';
  size?: 'small' | 'middle' | 'large';
  stickyHeader?: boolean;
  disabled?: boolean;
  onClear?: () => void;
  onSelect?: (id: string) => void;
  onDeselect?: (id: string) => void;
}

export const CustomerSelect: React.FC<IProps> = observer(
  ({ status, size, stickyHeader, disabled, onSelect, onDeselect }) => {
    const { customers, handleSearch } = useSelectCustomers();

    const options = useMemo(() => {
      return customers.map((customer) => ({
        label: customer.fullname + ' - ' + customer.email,
        value: customer.id,
      }));
    }, [customers]);

    return (
      <Select
        allowClear
        showSearch
        notFoundContent={null}
        filterOption={false}
        style={{ width: '100%' }}
        size={size}
        status={status}
        disabled={disabled}
        options={options}
        onSelect={onSelect}
        onSearch={handleSearch}
        onDeselect={onDeselect}
        placeholder={L('Enter customer name or email')}
        getPopupContainer={(stickyHeader && ((trigger: any) => trigger.parentElement)) || undefined}
      />
    );
  }
);
